// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as AuthStore$PorterinFeature from "../../../domain/store/AuthStore.mjs";
import * as CookieStore$PorterinFeature from "../../../../fare-estimate-v1/utils/browser/CookieStore.mjs";
import * as CookieUtils$PorterinFeature from "../../../../fare-estimate-v1/utils/browser/CookieUtils.mjs";
import * as AuthContextV1$PorterinFeature from "../../../view-model/contexts/auth-context/AuthContextV1.mjs";
import * as AuthRepoManager$PorterinFeature from "../../../domain/repo/AuthRepoManager.mjs";
import * as CustomerProfileModuleScss from "../../styles/CustomerProfile.module.scss";

var styles = CustomerProfileModuleScss;

function CustomerLogoutButtonCmp(Props) {
  var close_modal = Props.close_modal;
  var match = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var set_user = match.set_user;
  var set_is_authenticated = match.set_is_authenticated;
  return React.createElement("button", {
              className: styles["logout-button"],
              onClick: (function (param) {
                  var RepoInstance = AuthRepoManager$PorterinFeature.getAuthRepo(undefined);
                  var webTrackingId = CookieUtils$PorterinFeature.getCookie(CookieStore$PorterinFeature.web_tracking_id);
                  var auth_token = CookieUtils$PorterinFeature.getCookie(CookieStore$PorterinFeature.auth_token);
                  var mobile = CookieUtils$PorterinFeature.getCookie(CookieStore$PorterinFeature.mobile);
                  ApiUtils$Catalyst.handleAPIRequest((function (param) {
                          return Curry._3(RepoInstance.customerLogout, webTrackingId, auth_token, mobile);
                        }), (function (data) {
                          if (data.logout_success) {
                            CookieUtils$PorterinFeature.deleteCookie("auth-token");
                            CookieUtils$PorterinFeature.deleteCookie("mobile");
                            Curry._1(set_user, undefined);
                            Curry._1(set_is_authenticated, false);
                            return Curry._1(close_modal, undefined);
                          }
                          
                        }), (function (error) {
                          console.log(error);
                        }));
                })
            }, AuthStore$PorterinFeature.Profile.logout_button);
}

var make = CustomerLogoutButtonCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
